import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import { useMetaTags } from '../../services/useMetaTags';
import './errors.scss';

export default function ServerError() {
    const {t} = useTranslation();
    const homePath = '/';

    useMetaTags({
        title: `500 | ${t('app.title')}`,
        description: t('app.description'),
        metas: [{name: 'keywords', content: t('app.keywords')}],
    });

    return (
        <div className="spa-error-page spa-server-error-page">
            <div className="spa-server-error-content">
                <div className="spa-server-error-image">
                    <img src="/img/logo.svg" alt={t('app.accemedin')} />
                </div>
                <h1 dangerouslySetInnerHTML={{__html: t('errorPages.general.header')}} />
                <p dangerouslySetInnerHTML={{__html: t('errorPages.general.text')}} />
                <div className="spa-server-error-actions">
                    <Link to={homePath} className="btn">
                        {t('errorPages.notFound.backToMainTitle')}
                    </Link>
                </div>
            </div>
        </div>
    );
}
